/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MilestoneResponse
 */
export interface MilestoneResponse {
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof MilestoneResponse
     */
    target: number;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof MilestoneResponse
     */
    rewardConfig: RewardConfigResponse;
    /**
     * 
     * @type {string}
     * @memberof MilestoneResponse
     */
    name: string;
}

export function MilestoneResponseFromJSON(json: any): MilestoneResponse {
    return MilestoneResponseFromJSONTyped(json, false);
}

export function MilestoneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target': json['target'],
        'rewardConfig': RewardConfigResponseFromJSON(json['rewardConfig']),
        'name': json['name'],
    };
}

export function MilestoneResponseToJSON(value?: MilestoneResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target': value.target,
        'rewardConfig': RewardConfigResponseToJSON(value.rewardConfig),
        'name': value.name,
    };
}


